import { Component, input } from '@angular/core';
import { WorkInteraction } from '@work-frontend-monorepo/work-rest-api';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { IconComponent } from '../icon/icon.component';
import { NgClass } from '@angular/common';
import { AvatarComponent } from '../avatar/avatar.component';
import { FormatDatePipe } from '../../pipes/format-date.pipe';
import { PrependServerToFileSrcPipe } from '../../pipes/prepend-server-to-file-src.pipe';
import { GetActivitytypeIconPipe } from '../../pipes/get-activitytype-icon.pipe';
import { GetInteractiontypeIconPipe } from '../../pipes/get-interactiontype-icon.pipe';

@Component({
  selector: 'work-ui-timeline-interaction-item',
  templateUrl: './timeline-interaction-item.component.html',
  styleUrls: ['./timeline-interaction-item.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    IconComponent,
    RouterLink,
    TranslateModule,
    FormatDatePipe,
    AvatarComponent,
    PrependServerToFileSrcPipe,
    GetActivitytypeIconPipe,
    GetInteractiontypeIconPipe,
  ],
})
export class TimelineInteractionItemComponent {
  interaction = input.required<WorkInteraction>();
  tableStyle = input<boolean>(false);

  get isTask() {
    return this.interaction().assigneeId || this.interaction().duetime || this.interaction().endtime;
  }
}
